<div class="modal-content">
  <div class="modal-header">
    <div class="modal-header-left">
      <h4 class="modal-title">
        {{ getTitle() }}
      </h4>
    </div>
    <div class="modal-header-right">
      <button
        type="button"
        class="close"
        (click)="close()"
        data-dismiss="modal"
        aria-label="Close"
      >
        <i class="icon-close"></i>
      </button>
    </div>
  </div>
  <form
    *ngIf="actionType === 'CREATE_USER'"
    name="createUser"
    [formGroup]="form"
  >
    <div class="modal-body">
      <div class="form-group">
        <app-checkbox 
          [form]="form" 
          controlName="IsExternalUser" 
          label="External User (SSO)?"
          type="toggle"
          >
        </app-checkbox>
      </div>
      <div class="form-group">
        <app-input
          controlName="FirstName"
          [form]="form"
          type="text"
          [minlengthMessage]="minLengthErrorMessage"
          label="First Name"
        ></app-input>
      </div>
      <div class="form-group">
        <app-input
          controlName="LastName"
          [form]="form"
          type="text"
          [minlengthMessage]="minLengthErrorMessage"
          label="Last Name"
        ></app-input>
      </div>
      <div class="form-group">
        <app-input
          controlName="Email"
          [form]="form"
          type="email"
          label="Email"
          id="CreateUserEmail"
        ></app-input>
        <div *ngIf="emailExists" class="info-box error-box ng-star-inserted">
          <span class="text-danger"
            >User already exists, use the "Add existing user" option.
          </span>
        </div>
      </div>
      <div class="form-group">
        <app-input
          controlName="PhoneNumber"
          [form]="form"
          type="tel"
          [mask]="phoneMask"
          placeholder="(000) 000-0000"
          label="Phone Number"
        ></app-input>
      </div>

      <app-input
        *ngIf="formControls.IsExternalUser.value == false"
        controlName="Password"
        [form]="form"
        type="password"
        label="Password"
      ></app-input>

      <app-select
        label="Top-Level Role"
        [form]="form"
        [options]="topLevelRoles"
        controlName="Role"
      ></app-select>

      <app-select
        *ngIf="form.value.Role !== 'admin'"
        label="Role"
        [form]="form"
        [options]="applicationRoles"
        controlName="ApplicationRoleIds"
        [isLoading]="isAllRolesLoading[applicationKey]"
        [isError]="isAllRolesLoading['error-'+applicationKey]"
      ></app-select>
    </div>
    <div class="modal-footer modal-footer-custom-new01">
      <div class="modal-footer-bottom">
        <app-modal-action-btns
          [form]="form"
          [disabled]="form.invalid || emailExists"
          (onReject)="close()"
          (onConfirm)="createUserSubmit()"
          [useFormSubmit]="false"
        ></app-modal-action-btns>
      </div>
    </div>
  </form>
  <form
    *ngIf="actionType === 'INVITE_NEW_USER'"
    name="inviteUser"
    [formGroup]="form"
  >
    <div class="modal-body">
      <app-input
        controlName="Email"
        [form]="form"
        type="email"
        label="Email"
      ></app-input>

      <div class="form-group">
        <app-checkbox [form]="form" controlName="IsExternalUser" label="External User (SSO)?">
        </app-checkbox>
      </div>

      <div class="form-group">
        <app-checkbox [form]="form" controlName="IsAdmin" label="Is Admin?">
        </app-checkbox>
      </div>
      <div
        *ngIf="formControls.IsAdmin.value && formControls.BillingAdmin.value"
      >
        <app-select
          label="Subscription Pricing Plan"
          [form]="form"
          [options]="Products"
          controlName="StripeProductId"
          [isLoading]="isProductsLoading.isLoading"
          [isError]="isProductsLoading.isError"
        ></app-select>
      </div>
      <div *ngIf="formControls.IsAdmin.value === false">
        <app-select
          label="Role"
          [form]="form"
          [options]="applicationRoles"
          controlName="ApplicationRoleIds"
          [isLoading]="isAllRolesLoading[applicationKey]"
          [isError]="isAllRolesLoading['error-'+applicationKey]"
        ></app-select>
      </div>
    </div>
    <div class="modal-footer modal-footer-custom-new01">
      <div class="modal-footer-bottom">
        <app-modal-action-btns
          [form]="form"
          [disabled]="form.invalid || (!formControls.IsAdmin.value && !formControls.ApplicationRoleIds.value)"
          (onReject)="close()"
          (onConfirm)="inviteUserSubmit()"
          [useFormSubmit]="false"
        ></app-modal-action-btns>
      </div>
    </div>
  </form>
  <form
    *ngIf="actionType === 'ADD_EXISTING_USER'"
    name="addUser"
    [formGroup]="form"
  >
    <div class="modal-body">
      <div class="form-group select2-form-group">
        <!-- <app-select
          label="Users"
          [form]="form"
          [options]="companyUsers"
          controlName="UsersId"
        ></app-select> -->
        <app-select-search-scroll
          [label]="'Users'"
          [form]="form"
          controlName="UsersId"
          [isAddExistingUserComponent]="true"
          [minSearchLength]="3"
          [searchable]="true"
          [scrollable]="true"
          (selected)="setSelectedValue($event, form)"
        ></app-select-search-scroll>

        <app-select
          *ngIf="addExistingUserRole !== applicationRole.admin && addExistingUserRole !== applicationRole.superAdmin"
          label="Role"
          [form]="form"
          [options]="applicationRoles"
          controlName="ApplicationRoleIds"
          [isLoading]="isAllRolesLoading[applicationKey]"
          [isError]="isAllRolesLoading['error-'+applicationKey]"
        ></app-select>
      </div>
    </div>
    <div class="modal-footer modal-footer-custom-new01">
      <div class="modal-footer-bottom">
        <app-modal-action-btns
          [form]="form"
          (onReject)="close()"
          (onConfirm)="formSubmit()"
          [useFormSubmit]="false"
        ></app-modal-action-btns>
      </div>
    </div>
  </form>
  <form *ngIf="actionType === 'UPDATE_USER'" name="addUser" [formGroup]="form">
    <div class="modal-body">
      <app-input
        controlName="FirstName"
        [form]="form"
        type="text"
        label="First Name"
        [minlengthMessage]="minLengthErrorMessage"
      ></app-input>
      <app-input
        controlName="LastName"
        [form]="form"
        type="text"
        label="Last Name"
        [minlengthMessage]="minLengthErrorMessage"
      ></app-input>
      <app-input
        controlName="PhoneNumber"
        [form]="form"
        type="tel"
        [mask]="phoneMask"
        placeholder="(000) 000-0000"
        label="Phone Number"
      ></app-input>
      <app-input controlName="UserId" [form]="form" label="Email"></app-input>
      <app-checkbox *ngIf="!userDetails?.IsSuperAdmin" [form]="form" controlName="IsAdmin" label="Is Admin?" [disabled]="this.userDetails ? this.userDetails.IsAdmin ? true : false : false">
      </app-checkbox>
      <div class="form-group select2-form-group">
        <app-select
          *ngIf="form?.value?.IsAdmin === false && !userDetails?.IsSuperAdmin"
          label="Role"
          [form]="form"
          [options]="applicationRoles"
          [canClear]="this.userDetails ? this.userDetails.IsAdmin : false"
          controlName="role"
          (clear)="removeRole()"
          [isLoading]="isAllRolesLoading[applicationKey]"
          [isError]="isAllRolesLoading['error-'+applicationKey]"
        ></app-select>
      </div>
    </div>
    <div class="modal-footer modal-footer-custom-new01">
      <div class="modal-footer-bottom">
        <app-modal-action-btns
          [form]="form"
          (onReject)="close()"
          (onConfirm)="updateFormSubmit()"
          [useFormSubmit]="false"
        ></app-modal-action-btns>
      </div>
    </div>
  </form>
</div>
